<template>
    <div class="row">
        <div class="col-lg-4 form-group">
            <label style="width: 100%">
                First Name
                <small class="redText">required</small>
                <input type="text" name="firstName" class="form-control" placeholder="First Name" 
                    :disabled="viewOnly" v-model="model.firstName">
            </label>
        </div>
        <div class="col-lg-4 form-group">
            <label style="width: 100%">
                Middle Initial
                <input type="text" name="middleInitial" class="form-control" placeholder="Middle Initial" maxlength="1" 
                    :disabled="viewOnly" v-model="model.middleInitial">
            </label>
        </div>
        <div class="col-lg-4 form-group">
            <label style="width: 100%">
                Last Name
                <small class="redText">required</small>
                <input type="text" name="lastName" class="form-control" placeholder="Last Name" 
                    :disabled="viewOnly" v-model="model.lastName">
            </label>
        </div>
        <div class="col-lg-4 form-group">
            <label style="width: 100%">
                Phone Number
                <small v-if="showRequiredLabelForPrimaries" class="redText">required</small>
                <ac-phone-number v-model="model.phoneNbr" :readOnly="viewOnly" />
            </label>
        </div>
        <div class="col-lg-4 form-group">
            <label style="width: 100%">
                Email
                <small v-if="showRequiredLabelForPrimaries" class="redText">required</small>
                <input type="text" name="email" class="form-control" placeholder="Email" 
                    :disabled="viewOnly" v-model="model.emailAddress">
            </label>
        </div>
        <div class="col-lg-4 form-group">
            <label style="width: 100%" v-if="genders.length > 0">
                Gender
                <small class="redText">required</small>
                <select v-model="model.genderCode" type="text" class="form-control" :disabled="viewOnly">
                    <option v-for="gender in genders" :value="gender.genderCode">
                        {{ gender.genderName }}
                    </option>
                </select>
            </label>
        </div>
    </div>
</template>

<script>
    import {configTables} from "../../global/configTables.js";

    export default {
        name: "GenericProfileInfo",
        props: {
            viewOnly: {type: Boolean, required: false, default: false},
            value: {
                type: [Object],
                required: true,
            },
            showRequiredLabelForPrimaries: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                states: [],
                genders: [],
                titles: [],
                model: {...this.value}
            };
        },
        watch: {
            model: {
                deep: true,
                handler(value) {
                    this.$emit('input', value);
                    //console.log("Profile model property has been updated, value:", value);
                }
            }
        },
        mounted() {
            configTables.getGenders().then((genders) => this.genders = genders);
            configTables.getStates().then((states) => this.states = states);
            configTables.getTitles().then((titles) => {
                if (!Boolean(this.model.titleId)) {
                    this.model.titleId = null;
                }
                this.titles = titles;
            });
        }
    }
</script>

<style scoped>

</style>